<script setup>
import ViewOrganisation from '@/Pages/Organisations/View.vue'
import { useForm } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'

const form = useForm(props.organisation);

const props = defineProps({
    organisation: {
        type: Object,
        default: () => ({}),
    },
})

const updateOrganisation = (incoming) => {
	form.transform(() => incoming).put('/organisations/' + props.organisation.id)
}

const refreshOrganisation = () => {
	Inertia.reload({ only: ['organisation'] })
}

</script>

<template>
	<ViewOrganisation 
		:organisation="form" 
		@update:organisations="updateOrganisation"
		@refresh:organisations="refreshOrganisation"
	/>
</template>